import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const OrderSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  li > div {
    padding-left: 0;
    margin-left: ${primitive.$spacing4};
    border-bottom: ${p => p.theme.token('border-default')};
  }
  li:last-of-type > *:first-child {
    border-bottom: none;
  }
`;
